export default __webpack_public_path__ + "static/media/pinterest.c0bf18f9.png";